import React from 'react';
import { Controller } from "react-hook-form";
import {
  ACCOUNT_TYPES,
  INDIA_ACCOUNT_TYPES,
} from "../../../appconstants";
import {
  LabelText,
  Text,
  Input,
  H2Text,
} from "../../../design";
import {
  Row,
  Col,
} from 'antd';
import { ErrorMessage } from "@hookform/error-message";
import Select from "react-select";

type Props = {
  errors: Object,
  control: Object,
  transferType: String,
  alpha2: String,
  customerValidation: Object,
  isMobileView: Boolean,
  customH2TextStyle: Object,
  customLabelTextStyle: Object,
};

const IndiaFields = (props: Props) => {
  const {
    errors,
    control,
    transferType,
    alpha2,
    customerValidation,
    isMobileView,
    customH2TextStyle,
    customLabelTextStyle,
  } = props;

  const selectCustomStyles = {
    container: base => ({
      ...base,
      width: '100%',
      height: '41px',
      marginTop: '8px',
      marginBottom: '8px',
      borderRadius: '10px',
    }),
    control: base => ({
      ...base,
      height: '41px',
      minHeight: 33,
      border: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    }),
  };

  const customInputStyle = {
    background: 'white',
    // color: 'black',
    borderColor: '#CCCCCC',
    width: '100%',
    height: '41px',
    paddingLeft: '15px',
  }

  return (
    <Row>
      <Col span={24}>
        {/* india and upi enabled */}
        {(transferType?.includes('UPI') && alpha2 === 'IN') && (
          <>
            <Row>
              <Col span={24}>
                <H2Text {...customH2TextStyle}>UPI Details</H2Text>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <LabelText {...customLabelTextStyle}>
                  UPI ID
                </LabelText>
                <Controller
                  defaultValue={""}
                  color={errors.vpa ? "red" : "inherit"}
                  marginBottom="0px"
                  control={control}
                  name="vpa"
                  placeholder="Enter your upi id"
                  rules={{
                    required: 'This field is required',
                    pattern: {
                      value: /^\w.+@\w+$/,
                      message: 'The upi id is invalid',
                    },
                  }}
                  as={<Input className="w-100" />}
                />
                <ErrorMessage
                  errors={errors}
                  name="vpa"
                  render={({ message }) => (
                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                  )}
                />
              </Col>
            </Row>
          </>
        )}
        {/* india based bank info */}
        {(!transferType?.includes('UPI') && alpha2 === 'IN') && (
        <>
          <Row>
            <Col span={24}>
              <H2Text {...customH2TextStyle}>Bank Details</H2Text>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={isMobileView ? 24 : 12}>
              <LabelText {...customLabelTextStyle} style={{ color: 'black' }}>
                Bank Name
              </LabelText>
              <Controller
                defaultValue={""}
                color={errors.bankName ? "red" : "inherit"}
                marginBottom="0px"
                control={control}
                name="bankName"
                placeholder="Enter bank name"
                rules={{
                  required: 'This field is required',
                  pattern: {
                    value: /^[a-zA-Z ]+$/,
                    message: 'Bank name must be valid',
                  },
                }}
                as={<Input style={{ ...customInputStyle }}/>}
              />
              <ErrorMessage
                errors={errors}
                name="bankName"
                render={({ message }) => (
                  <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                )}
              />
            </Col>
            <Col span={isMobileView ? 24 : 12}>
              <LabelText {...customLabelTextStyle} style={{ color: 'black' }}>
                Account Type
              </LabelText>
              <Controller
                defaultValue={""}
                color={errors.accountType ? "red" : "inherit"}
                marginBottom="0px"
                control={control}
                name="accountType"
                placeholder="select"
                rules={{
                  required: 'Account type is required'
                }}
                as={<Select
                  className="px-0 border-0"
                  getOptionLabel={(option) => option.value}
                  styles={selectCustomStyles}
                  options={alpha2 === "IN" ? INDIA_ACCOUNT_TYPES.map(value => { return { value } }) : ACCOUNT_TYPES.map(value => { return { value } })} />}
              />
              <ErrorMessage
                errors={errors}
                name="accountType"
                render={({ message }) => (
                  <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                )}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={isMobileView ? 24 : 12}>
              <LabelText {...customLabelTextStyle} style={{ color: 'black' }}>
                Account Holder Name
              </LabelText>
              <Controller
                defaultValue={""}
                color={errors.accountHolderName ? "red" : "inherit"}
                marginBottom="0px"
                control={control}
                name="accountHolderName"
                placeholder="Enter account holder name"
                rules={{
                  required: 'This field is required',
                  pattern: {
                    value: /^[a-zA-Z ]+$/,
                    message: 'Bank Holder name must be valid',
                  },
                }}
                as={<Input style={{ ...customInputStyle }} />}
              />
              <ErrorMessage
                errors={errors}
                name="accountHolderName"
                render={({ message }) => (
                  <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                )}
              />
            </Col>
            <Col span={isMobileView ? 24 : 12}>
              <LabelText {...customLabelTextStyle} style={{ color: 'black' }}>
                Bank Account Number
              </LabelText>
              <Controller
                defaultValue={""}
                color={errors.accountNumber ? "red" : "inherit"}
                marginBottom="0px"
                control={control}
                name="accountNumber"
                placeholder="Enter account number"
                rules={{
                  required: 'This field is required',
                  pattern: {
                    value: /^\s*[0-9]{6,17}\s*$/,
                    message: 'The account number is invalid',
                  },
                }}
                as={<Input style={{ ...customInputStyle }} />}
              />
              <ErrorMessage
                errors={errors}
                name="accountNumber"
                render={({ message }) => (
                  <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                )}
              />
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={isMobileView ? 24 : 12}>
              <LabelText {...customLabelTextStyle} style={{ color: 'black' }}>IFSC Code</LabelText>
              <Controller
                defaultValue={""}
                color={errors.routingNumber ? "red" : "inherit"}
                marginBottom="0px"
                control={control}
                name="routingNumber"
                placeholder="Enter IFSC Code"
                rules={customerValidation && {
                  required: 'This field is required',
                  pattern: {
                    value: /^[A-Za-z]{4}0[A-Z0-9a-z]{6}$/,
                    message: 'The IFSC Code is invalid',
                  },
                }}
                as={<Input style={{ ...customInputStyle }} />}
              />
              <ErrorMessage
                errors={errors}
                name="routingNumber"
                render={({ message }) => (
                  <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                )}
              />
            </Col>
          </Row>
        </>
        )}
      </Col>
    </Row>
  );
};

export default IndiaFields;
